import { type GroupDetail, createGroupDetail } from 'models';
import { useQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getGroupDetail } from '../services';
import { getGroupDetailQueryKey } from './keys';

export const useGroupDetailQuery = ({ groupId }: { groupId: string }) =>
  useQuery<GroupDetail, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn() {
      const { data } = await getGroupDetail({
        routeParams: {
          id: groupId,
        },
      });

      return createGroupDetail(data);
    },
    queryKey: getGroupDetailQueryKey({ groupId }),
  });
